import React from "react";
import { Search } from "../../Search";
import BaseModal, { MODALSIZES } from "../BaseModal";
import ModalEnum from "../BaseModal/ModalEnum";
import { AutomationPlacement } from '../../../utilities/automation';
import useLanguage from "../../../utilities/useLanguage";
import { getTranslation } from '../translations';


type SearchModalProps = {
    isBlogSearch?: boolean;
};

const SearchModal: React.FC<SearchModalProps> = ({ isBlogSearch }) => {
    const { lang } = useLanguage();

    return (
        <BaseModal backdropClassName={"modal-backdrop-glass"} modalId={isBlogSearch ? ModalEnum.BlogSearch : ModalEnum.Search} modalSize={MODALSIZES.SEARCH}>
            <h5 className="mb-4 text-dark text-center">{isBlogSearch ? getTranslation(lang).searchOurArticles : getTranslation(lang).whatCanWeHelpYouWith}</h5>
            <Search
                placement={AutomationPlacement.MODAL}
                inputPlaceholder={getTranslation(lang).startTypingHere}
                focus
                inputClass="text-dark bg-transparent"
                containerClass="rounded-pill bg-white"
                lineColor="#4D4D4F"
                buttonClass="black"
                pageType={isBlogSearch ? "blog" : null}
                // You can pass isBlogSearch to Search if needed in the future
            />
        </BaseModal>
    );
};

export default SearchModal;
